import {useProfile} from "~/lib/profile-context";
import {SubscriptionTier} from "~/queries/subscription";

export const useSubscriptionTier = (): SubscriptionTier | null => {
    const { profile } = useProfile();

    return profile?.subscriptionTier || null;
}